import * as React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import alarmTriangle from '../../assets/icons/warning-triangle--red.svg';
import {
  SCancelButton,
  SConfirmButton,
  SModalWrapper,
  SOverLay,
  SDescription,
} from '../ConfirmDialog/style';
import {
  SButtonWrapper,
  SModalContainer,
  SNotificationIcon,
  STenantName,
  STextContainer,
  STitle,
} from './NotificationModal.styles';

type INotificationModalProps = {
  isOpen: boolean;
  title: string;
  description: string;
  tenantName?: string;
  onSubmit: () => void;
  onCancel: () => void;
  confirmText: string;
  cancelText: string;
  titleColor: 'white' | 'green';
  showIcon: boolean | undefined;
  showModal: boolean;
  closeBtnOnly: boolean | undefined;
};

const NotificationModal = (props: INotificationModalProps) => {
  const {
    isOpen,
    title,
    description,
    tenantName,
    onSubmit,
    onCancel,
    confirmText,
    cancelText,
    titleColor,
    showIcon,
    closeBtnOnly,
  } = props;

  const { t } = useTranslation();

  return isOpen
    ? ReactDOM.createPortal(
        <React.Fragment>
          <SOverLay />
          <SModalWrapper>
            <SModalContainer>
              {showIcon && (
                <SNotificationIcon src={alarmTriangle} alt="alarm icon"></SNotificationIcon>
              )}
              <STextContainer>
                <STitle className={showIcon ? 'activatedAlarmTitle' : ''} titleColor={titleColor}>
                  {title}
                </STitle>
                {tenantName && <STenantName>{tenantName}</STenantName>}
                <SDescription>{description}</SDescription>
              </STextContainer>
              <SButtonWrapper closeBtnOnly={closeBtnOnly}>
                {onCancel && (
                  <SCancelButton className="button" onClick={onCancel}>
                    {t(cancelText)}
                  </SCancelButton>
                )}
                {onSubmit && !closeBtnOnly && (
                  <SConfirmButton className="button" onClick={() => onSubmit()}>
                    {t(confirmText)}
                  </SConfirmButton>
                )}
              </SButtonWrapper>
            </SModalContainer>
          </SModalWrapper>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default NotificationModal;
